import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { IAction } from '../../action/IAction'
import type { AiCreditTransaction } from './AiCreditTransaction'
import type { EntityMeta } from '../../base/EntityMeta'

/**
 * Same shape as `GetAiCreditTransactionListArgs` — the owner scope rides inside `filter`
 * (`filter.ownerId`), guarded in `scopeToOwnerDebitFilter` (`ai-common`).
 */
@InputType()
export class GetAiCreditTransactionListMetaArgs extends QueryArgs<AiCreditTransaction> {}

export interface IGetAiCreditTransactionListMeta extends IAction<EntityMeta, GetAiCreditTransactionListMetaArgs> {}
